var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shared-schedules-list',{attrs:{"individual-mode":true,"institution-account":_vm.isInstitution,"allow-modifying":!!_vm.isProviderOwnerOrAdmin,"breadcrumbs":_vm.breadcrumbs}})}
var staticRenderFns = []

export { render, staticRenderFns }